module.exports = __webpack_public_path__ + "img/33_2025_04_15.f1f4ae41.jpg";